/*/=======================================================================================\*\
|| IMPORTS DE DEPENDENCIAS                                                                 ||
\*\=======================================================================================/*/
import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ROUTES } from './const/routes';
import { UserProvider } from './context/UserContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute/AdminProtectedRoute';
import SessionExpiredModal from './components/SessionExpiredModal/SessionExpiredModal';
import { Analytics } from '@vercel/analytics/react';

/*/=======================================================================================\*\
|| IMPORTS DE RUTAS PROPIAS DEL SITIO                                                      ||
\*\=======================================================================================/*/
// Inicio Sitio
import Inicio from './pages/Inicio/Inicio';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
// Juegos
import ListaJuegos from './pages/Juegos/ListaJuegos/ListaJuegos';
import Ruleta from './pages/Juegos/Ruleta/Ruleta';
import Tragamonedas from './pages/Juegos/Tragamonedas/Tragamonedas';
import BlackJack from './pages/Juegos/BlackJack/BlackJack';
// Historial
import Historial from './pages/Historial/Historial';
// Detalle Jugada
import DetallesJugada from './pages/DetalleJugada/DetalleJugada';
// Movimientos
import Movimientos from './pages/Movimientos/Movimientos';
// CargarSaldo
import ListaCargaSaldo from './pages/CargarSaldo/ListaCargaSaldo/ListaCargaSaldo';
import EleccionCargaSaldo from './pages/CargarSaldo/EleccionCargaSaldo/EleccionCargaSaldo';
import MercadoPagoFailure from './pages/CargarSaldo/MercadoPagoFailure/MercadoPagoFailure';
import MercadoPagoSuccess from './pages/CargarSaldo/MercadoPagoSuccess/MercadoPagoSuccess';
import MercadoPagoPending from './pages/CargarSaldo/MercadoPagoPending/MercadoPagoPending';
// Perfil
import Perfil from './pages/Perfil/Perfil';
// Editar Perfil
import EditarPerfil from './pages/EditarPerfil/EditarPerfil';
// Ranking
import Ranking from './pages/Ranking/Ranking';
// Historial Jugador (público)
import HistorialJugador from './pages/HistorialJugador/HistorialJugador';
// Que es Casino Print
import QueCasinoPrint from './pages/QueCasinoPrint/QueCasinoPrint';
// Admin
import AdminUsuarios from './pages/Admin/AdminUsuarios';
import AdminUsuarioDetalle from './pages/Admin/AdminUsuarioDetalle';
// Verificación y Reset
import VerificarEmail from './pages/VerificarEmail/VerificarEmail';
import OlvidoContrasenia from './pages/OlvidoContrasenia/OlvidoContrasenia';
import ResetContrasenia from './pages/ResetContrasenia/ResetContrasenia';
import NotFound from './pages/NotFound/NotFound';

/*/=======================================================================================\*\
|| DEFINICIÓN DE RUTAS                                                                     ||
\*\=======================================================================================/*/
const router = createBrowserRouter([
  // Inicio Sitio
  {
    path: ROUTES.inicio,
    element: <Inicio />,
  },
  {
    path: ROUTES.queCasinoPrint,
    element: <QueCasinoPrint />,
  },
  {
    path: ROUTES.login,
    element: <Login />,
  },
  {
    path: ROUTES.register,
    element: <Register />,
  },
  {
    path: ROUTES.verificarEmail,
    element: <VerificarEmail />,
  },
  {
    path: ROUTES.olvidoContrasenia,
    element: <OlvidoContrasenia />,
  },
  {
    path: ROUTES.resetContrasenia,
    element: <ResetContrasenia />,
  },
  // Juegos
  {
    path: ROUTES.listaJuegos,
    element: (
      <ProtectedRoute>
        <ListaJuegos />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.ruleta,
    element: (
      <ProtectedRoute>
        <Ruleta />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.tragamonedas,
    element: (
      <ProtectedRoute>
        <Tragamonedas />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.blackJack,
    element: (
      <ProtectedRoute>
        <BlackJack />
      </ProtectedRoute>
    ),
  },
  // Historial
  {
    path: ROUTES.historial,
    element: (
      <ProtectedRoute>
        <Historial />
      </ProtectedRoute>
    ),
  },
  {
    path: `${ROUTES.detallesJugada}/:idJugada`,
    element: (
      <ProtectedRoute>
        <DetallesJugada />
      </ProtectedRoute>
    ),
  },
  // Movimientos
  {
    path: ROUTES.movimientos,
    element: (
      <ProtectedRoute>
        <Movimientos />
      </ProtectedRoute>
    ),
  },
  // CargarSaldo
  {
    path: ROUTES.listaCargaSaldo,
    element: (
      <ProtectedRoute>
        <ListaCargaSaldo />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.eleccionCargaSaldo,
    element: (
      <ProtectedRoute>
        <EleccionCargaSaldo />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.mercadoPagoFailure,
    element: (
      <ProtectedRoute>
        <MercadoPagoFailure />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.mercadoPagoPending,
    element: (
      <ProtectedRoute>
        <MercadoPagoPending />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.mercadoPagoSuccess,
    element: (
      <ProtectedRoute>
        <MercadoPagoSuccess />
      </ProtectedRoute>
    ),
  },
  // Perfil
  {
    path: ROUTES.perfil,
    element: (
      <ProtectedRoute>
        <Perfil />
      </ProtectedRoute>
    ),
  },
  // Editar Perfil
  {
    path: ROUTES.editarPerfil,
    element: (
      <ProtectedRoute>
        <EditarPerfil />
      </ProtectedRoute>
    ),
  },
  // Ranking
  {
    path: ROUTES.ranking,
    element: (
      <ProtectedRoute>
        <Ranking />
      </ProtectedRoute>
    ),
  },
  // Historial de otro jugador (público)
  {
    path: `${ROUTES.historialJugador}/:userId`,
    element: (
      <ProtectedRoute>
        <HistorialJugador />
      </ProtectedRoute>
    ),
  },
  // Admin
  {
    path: ROUTES.admin,
    element: (
      <AdminProtectedRoute>
        <AdminUsuarios />
      </AdminProtectedRoute>
    ),
  },
  {
    path: `${ROUTES.adminUsuarioDetalle}/:id`,
    element: (
      <AdminProtectedRoute>
        <AdminUsuarioDetalle />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

function App() {
  return (
    <UserProvider>
      <div className="App">
        <header className="App-header">
          <RouterProvider router={router} />
        </header>
        <SessionExpiredModal />
        <Analytics />
      </div>
    </UserProvider>
  );
}

export default App;
